import { element } from 'angular';

/**
 * @deprecated
 */
export let LacksPermissionDirective = [
  '$animate',
  '$compile',
  'sessionDeprecatedService',
  ($animate, $compile, session) => {
    function lacksPermission(permission) {
      return !session.hasPermission(permission);
    }

    return {
      multiElement: true,
      transclude: true,
      priority: 600,
      terminal: true,
      restrict: 'A',
      $$tlb: true,
      link: (scope, elem, attr, _, $transclude) => {
        let block;
        let childScope;
        let previousElements;

        let getBlockNodes = nodes => {
          let node = nodes[0];
          let endNode = nodes[nodes.length - 1];
          let blockNodes = [node];

          do {
            node = node.nextSibling;
            if (!node) break;
            blockNodes.push(node);
          } while (node !== endNode);

          return element(blockNodes);
        };

        scope.$watch(attr.lacksPermission, value => {
          if (lacksPermission(value)) {
            if (!childScope) {
              $transclude((clone, newScope) => {
                childScope = newScope;
                clone[clone.length++] = $compile.$$createComment('end lacksPermission', value);
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone,
                };
                $animate.enter(clone, elem.parent(), elem);
                newScope.$on('$destroy', () => {
                  clone.remove();
                });
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).then(() => {
                previousElements = null;
              });
              block = null;
            }
          }
        });

        // fix to prevent memory leak
        scope.$on('$destroy', () => {
          // remove listener
        });
        elem.on('$destroy', () => {
          scope.$destroy();
        });
      },
    };
  },
];

export default 'lacksPermission';
